import {Injectable} from '@angular/core';
import {DateRange, DefaultMatCalendarRangeStrategy} from '@angular/material/datepicker';
import {DateAdapter} from '@angular/material/core';

@Injectable()
export class FutureDayRangeSelectionStrategy extends DefaultMatCalendarRangeStrategy<Date> {
  constructor(_dateAdapter: DateAdapter<Date>) {
    super(_dateAdapter);
  }

  selectionFinished(date: Date, currentRange: DateRange<Date>): DateRange<Date> {
    if (currentRange && currentRange.start && currentRange.start < new Date()) {
      return new DateRange(currentRange.start, date);
    } else {
      return super.selectionFinished(date, currentRange);
    }
  }

  createPreview(activeDate: Date | null, currentRange: DateRange<Date>): DateRange<Date> {
    if (currentRange && currentRange.start && currentRange.start < new Date()) {
      return new DateRange(currentRange.start, activeDate);
    } else {
      return super.createPreview(activeDate, currentRange);
    }
  }

}
